import React, { ChangeEvent } from 'react'
import { CheckboxItem } from 'types'

interface Props {
  items: CheckboxItem[]
  onCheckboxChange: (event: ChangeEvent<HTMLInputElement>) => void
}

const ShowHideColumns = ({ items, onCheckboxChange }: Props) => (
  <div id='show-hide-columns'>
    <h4>Visible Columns</h4>
    <ul className='checkbox-list'>
      {items.map((item) => {
        const key = `list-item-${item.key.toLowerCase()}`
        return (
          <li key={key}>
            <label htmlFor={key}>
              <input
                id={key}
                type='checkbox'
                data-item-key={item.key}
                checked={item.checked}
                onChange={onCheckboxChange}
              />
              {item.label}
            </label>
          </li>
        )
      })}
    </ul>
  </div>
)

export default ShowHideColumns
